import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" {...this.props}><title>Group 31</title><g fill="none" fillRule="evenodd"><circle cx="19" cy="19" r="19" fill="#3B5998" /><path d="M20.742 29v-9.123h3.062l.458-3.555h-3.52v-2.27c0-1.03.285-1.731 1.762-1.731l1.882-.001V9.14A25.197 25.197 0 0 0 21.643 9c-2.715 0-4.573 1.657-4.573 4.7v2.622H14v3.555h3.07V29h3.672z" fill="#FEFEFE" /></g></svg>;
  }

}